import React, { useMemo, useState } from 'react';
import ReactSelect from 'react-select';

import { useBreakpoint } from '@context/BreakpointProvider';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { mq } from '@helpers/breakpoints';
import Colors from '@theme/colors';

interface FormSelectProps {
  options: [{ value: string; label: string }];
  name: string;
  value: string;
  placeholder: string;
  size: { width: number };
  setFieldValue(name: string, value: string): void;
  onChange(e: any): void;
}

const customStyles = (isMobile: boolean) => {
  return {
    option: (provided: any, state: any) => ({
      ...provided,
    }),
    control: (provided: any, state: any) => {
      return { ...provided, height: '55px' };
    },
    valueContainer: (provided: any, state: any) => {
      return { ...provided, overflow: 'visible' };
    },
    singleValue: (provided: any, state: any) => {
      return { ...provided, fontSize: '1.3em' };
    },
    container: (provided: any) => {
      return { ...provided, width: '100%' };
    },
  };
};

const FormSelectStyle = () => css`
  ${mq({
    fontSize: '1.3em',
    height: ['40px', '70px'],
    border: `2px solid ${Colors.grayLight9}`,
    borderRadius: '7px',
    width: '100%',
  })};
  background-color: ${Colors.neutral0};
`;

const FormSelect = ({ options, name, value, setFieldValue, onChange, placeholder }: FormSelectProps) => {
  const option = useMemo(() => options.find((item) => item.value === value), [value]);
  const [menuOpened, openMenu] = useState(false);
  const { isMobile } = useBreakpoint();

  return (
    <ReactSelect
      classNamePrefix={`${name}-select`}
      onChange={(e: { label: string; value: string }) => {
        // Date select types have a specific way of handling events
        openMenu(false);
        if (name === 'month') {
          onChange(e);
        } else {
          setFieldValue(name, e.value);
        }
      }}
      blurInputOnSelect={true}
      onFocus={() => openMenu(true)}
      onBlur={() => openMenu(false)}
      styles={customStyles(isMobile)}
      options={options}
      value={option}
      placeholder={placeholder}
      menuIsOpen={menuOpened}
      isSearchable={false}
    />
  );
};

const FormSelectStyled = styled(FormSelect)`
  ${FormSelectStyle}
`;

export default FormSelectStyled;
